"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$ = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$outboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$inboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$ = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$outboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$inboundSchema = void 0;
exports.getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityToJSON = getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityToJSON;
exports.getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityFromJSON = getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityFromJSON;
exports.getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestToJSON = getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestToJSON;
exports.getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestFromJSON = getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$;
(function (GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$) {
    /** @deprecated use `GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$inboundSchema` instead. */
    GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$.inboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$inboundSchema;
    /** @deprecated use `GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$outboundSchema` instead. */
    GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$.outboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$outboundSchema;
})(GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$ || (exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$ = GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$ = {}));
function getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityToJSON(getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity) {
    return JSON.stringify(exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$outboundSchema
        .parse(getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity));
}
function getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetSecurity' from JSON`);
}
/** @internal */
exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$;
(function (GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$) {
    /** @deprecated use `GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$inboundSchema` instead. */
    GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$.inboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$inboundSchema;
    /** @deprecated use `GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$outboundSchema` instead. */
    GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$.outboundSchema = exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$outboundSchema;
})(GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$ || (exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$ = GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$ = {}));
function getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestToJSON(getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest) {
    return JSON.stringify(exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$outboundSchema
        .parse(getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest));
}
function getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGetRequest' from JSON`);
}
//# sourceMappingURL=getnationalpricepersquarefootstatssalesnationalaveragepricepersquarefootget.js.map